import "esbuild-css-modules-plugin-ns-css:src/js/components/radioButton/radioButton.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/radioButton/radioButton.module.css:injector.js";
export default new Proxy({
  "customRadio": "radioButton-module__customRadio_a2aXtG__1100",
  "radioContainer": "radioButton-module__radioContainer_a2aXtG__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      